// Condition definitions
export const CONDITIONS = [
  {
    value: "new",
    label: "New (Sealed/Mint in Package)",
    description:
      "Never opened, factory-sealed, and includes all original packaging and accessories. Perfect, untouched condition.",
  },
  {
    value: "pre-owned",
    label: "Pre-owned (Used)",
    description: "The item has been opened, displayed, or played with. Condition varies: requires a 1–10 grade.",
  },
  {
    value: "custom",
    label: "Custom",
    description: "The item has been modified, repainted, or otherwise customized. Also requires a 1–10 grade.",
  },
]

// Grade descriptions
export const GRADE_DESCRIPTIONS = {
  1: {
    label: "For Parts (Non-Functional)",
    description: "Beyond practical repair. Only suitable for salvaging pieces or creative scrap projects.",
  },
  2: {
    label: "Heavily Damaged (Restoration/Spare Parts)",
    description:
      "Substantial damage or non-functionality. Could be worth restoring if rare, but mostly suitable for parts.",
  },
  3: {
    label: "Damaged (Broken/Incomplete)",
    description: "Major flaws, breaks, or missing essential pieces. May need repairs or serve as a donor for parts.",
  },
  4: {
    label: "Worn (Heavy Wear)",
    description:
      'Heavy usage marks, possible cracks, or missing more critical accessories. Still possibly displayable in a "vintage" or distressed look.',
  },
  5: {
    label: "Fair (Significant Wear)",
    description:
      "Pronounced damage or missing minor accessories. The figure/toy remains basically intact but shows substantial signs of age or use.",
  },
  6: {
    label: "Good (Visible Wear)",
    description:
      "Clearly used with evident scuffs, small dents, or paint wear. All major parts intact; fully displayable for less picky collectors.",
  },
  7: {
    label: "Very Good (Slight Imperfections)",
    description: "Noticeable but moderate marks, paint chips, or wear. Overall still a solid collectible.",
  },
  8: {
    label: "Excellent (Minor Wear)",
    description: "Light scratches, scuffs, or subtle signs of handling. Still highly displayable.",
  },
  9: {
    label: "Near Mint (Superb Condition)",
    description:
      "Extremely minor imperfections noticeable only on very close inspection. Maintains excellent presentation value.",
  },
  10: {
    label: "Mint (Collector-Grade)",
    description: "Perfect or near-perfect condition with virtually no flaws. Ideal for serious collectors.",
  },
}

